var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-modal',{ref:"modalRef",attrs:{"title":'Select a Member',"size-class":'modal-lg'}},[[_c('table',{ref:"grid",staticClass:"mdl-data-table table table-responsive dataTable no-footer dtr-inline",attrs:{"width":"100%"}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }